import { render, staticRenderFns } from "./RegisterCoaching.vue?vue&type=template&id=670f7458&scoped=true&"
import script from "./RegisterCoaching.vue?vue&type=script&lang=js&"
export * from "./RegisterCoaching.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCoaching.vue?vue&type=style&index=0&id=670f7458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f7458",
  null
  
)

export default component.exports